import { useContext } from 'react'
import AuthContextExtranet from '../context/AuthProviderExtranet'

const useAuthExtranet = () => {
  return useContext(AuthContextExtranet)
}

export default useAuthExtranet
